module.exports = __webpack_public_path__ + "6083716926041f46df2468797a4d4e61.png";